module.exports = __webpack_public_path__ + "static/media/breastfeeding-uncropped.96e19e1b.png";